import React from 'react';

export const IconAcomba: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 35 35" aria-hidden="true" {...props}>
        <g transform="translate(-341.638 -515.692)">
            <g transform="translate(341.638 515.692)">
                <path d="M359.138,533.192v-17.5a17.5,17.5,0,1,0,17.5,17.5Z" transform="translate(-341.638 -515.692)" fill="#0cc6de" />
                <path d="M367.175,523.692H349.638l12.4,12.4A17.484,17.484,0,0,0,367.175,523.692Z" transform="translate(-332.176 -506.23)" fill="#0099b7" />
            </g>
            <g transform="translate(366.554 515.692)">
                <path d="M363.122,525.577h-2.5V524.8a4.044,4.044,0,0,1-2.7.98,4.874,4.874,0,0,1-3.654-1.638,5.2,5.2,0,0,1-1.236-3.4,4.86,4.86,0,0,1,4.753-5.051,4.441,4.441,0,0,1,2.834.978v-.778h2.5Zm-2.6-6.291a2.971,2.971,0,0,0-2.4-1.2,2.648,2.648,0,0,0,.061,5.289,2.83,2.83,0,0,0,2.335-1.2Z" transform="translate(-353.038 -515.692)" fill="#0cc6de" />
            </g>
        </g>
    </svg>
);
